function MysticSymbols() {
  return (
    <>
      <div className="mystic-float" style={{ left: "5%", animationDuration: "18s" }}>☽</div>
      <div className="mystic-float" style={{ left: "15%", animationDuration: "22s" }}>✦</div>
      <div className="mystic-float" style={{ left: "30%", animationDuration: "16s" }}>⊕</div>
      <div className="mystic-float" style={{ left: "55%", animationDuration: "20s" }}>♆</div>
      <div className="mystic-float" style={{ left: "70%", animationDuration: "25s" }}>✧</div>
      <div className="mystic-float" style={{ left: "85%", animationDuration: "19s" }}>☾</div>
      <div className="mystic-float" style={{ left: "45%", animationDuration: "23s" }}>⚝</div>
    </>
  );
}

export default MysticSymbols;